import { currencyIcons } from "../data";

function Price({ price }) {
    return (
        <span className="price btn btn-outline-primary border-secondary">
            {price.currency === "MR" ? (
                "Mission Reward"
            ) : (
                <>
                    {Number(price.amount).toLocaleString()}
                    <img
                        src={
                            process.env.PUBLIC_URL +
                            "/img/currencies/" +
                            currencyIcons[price.currency]
                        }
                        className="ms-1"
                        alt={`${price.currency} icon`}
                        style={{
                            height: "1rem",
                            marginTop: "-.25rem",
                        }}
                    />
                </>
            )}
        </span>
    );
}

export default Price;
